(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3454],{

/***/ 98424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Percent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var shared_lib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69385);
/* harmony import */ var _percent_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80213);
/* harmony import */ var _percent_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_percent_module_scss__WEBPACK_IMPORTED_MODULE_3__);





const Percent = (props)=>{
    const percent = Number(props.children);
    const red = percent < 1;
    const green = false; // percent >= 1.1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_percent_module_scss__WEBPACK_IMPORTED_MODULE_3___default().percent), props.colorized && red && (_percent_module_scss__WEBPACK_IMPORTED_MODULE_3___default().red), props.colorized && green && (_percent_module_scss__WEBPACK_IMPORTED_MODULE_3___default().green), props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children !== false && props.children !== undefined && (0,shared_lib__WEBPACK_IMPORTED_MODULE_4__/* .formatPercent */ .T)(percent)
    });
};
Percent.defaultProps = {};


/***/ }),

/***/ 77414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var modules_layout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57711);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pages_company_finances_education_layout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22253);
/* harmony import */ var pages_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8254);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32636);
/* harmony import */ var shared_ui__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(76780);
/* harmony import */ var _table_of_content_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16269);
/* harmony import */ var _table_of_content_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_table_of_content_module_scss__WEBPACK_IMPORTED_MODULE_9__);











const list = [
    "Что такое финансовое планирование?",
    "Построим финансовую модель",
    "Задача: Укажите ваши переменные и постоянные расходы",
    "Считаем расходы",
    "Задача: Укажите ваши переменные и постоянные расходы",
    "Чем прибыльная компания отличается от неприбыльной?",
    "Задача: Заложите в фин. модель отчисления на резерв и возврат инвестиций",
    "Точка безубыточности-2 и система фондов",
    "План бюджета на месяц",
    "Создадим бюджет на месяц на основе финансовой модели",
    "Задача: Составьте бюджет на месяц",
    "Как добиться выполнения плана?",
    "Контроль трат. Заявки на расход и выплаты.",
    "Каждую неделю – еженедельное финансовое планирование",
    "Итоги"
];
const TableOfContentPage = ()=>{
    const companySlug = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().query.company;
    const educationRouter = pages_router__WEBPACK_IMPORTED_MODULE_5__/* ["default"].company */ .Z.company(companySlug).finances.education;
    const settings = shared_api__WEBPACK_IMPORTED_MODULE_6__/* .api.financeSettings.useFinanceSettingsGet */ .h.financeSettings.useFinanceSettingsGet(companySlug);
    const onContinue = async ()=>{
        if (!settings.data) return;
        if (settings.data.educationStep < 1) {
            await shared_api__WEBPACK_IMPORTED_MODULE_6__/* .api.financeSettings.financeSettingsUpdateEducationStep */ .h.financeSettings.financeSettingsUpdateEducationStep(companySlug, {
                educationStep: 1
            });
            await next_router__WEBPACK_IMPORTED_MODULE_3___default().push(educationRouter.step(1).href);
            return;
        }
        await next_router__WEBPACK_IMPORTED_MODULE_3___default().push(educationRouter.step(settings.data.educationStep).href);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_company_finances_education_layout__WEBPACK_IMPORTED_MODULE_7__/* .FinancesEducationLayout */ .A, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_layout__WEBPACK_IMPORTED_MODULE_8__/* .Container */ .W, {
            className: (_table_of_content_module_scss__WEBPACK_IMPORTED_MODULE_9___default().table_of_content),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_table_of_content_module_scss__WEBPACK_IMPORTED_MODULE_9___default().inner),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: "Оглавление"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_table_of_content_module_scss__WEBPACK_IMPORTED_MODULE_9___default().list),
                        children: list.map((it, key)=>{
                            var _settings_data;
                            const active = key < ((_settings_data = settings.data) === null || _settings_data === void 0 ? void 0 : _settings_data.educationStep);
                            const step = key + 1;
                            const href = educationRouter.step(step).href;
                            const Wrapper = active ? (next_link__WEBPACK_IMPORTED_MODULE_2___default()) : "div";
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
                                href: href,
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_table_of_content_module_scss__WEBPACK_IMPORTED_MODULE_9___default().item), active && (_table_of_content_module_scss__WEBPACK_IMPORTED_MODULE_9___default().active)),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_table_of_content_module_scss__WEBPACK_IMPORTED_MODULE_9___default().number),
                                        children: [
                                            step,
                                            "."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_table_of_content_module_scss__WEBPACK_IMPORTED_MODULE_9___default().name),
                                        children: it
                                    })
                                ]
                            }, step);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_table_of_content_module_scss__WEBPACK_IMPORTED_MODULE_9___default().actions),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .z, {
                            onClick: onContinue,
                            children: "Продолжить"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (TableOfContentPage);


/***/ }),

/***/ 81386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FinancesPlansPage": function() { return /* binding */ FinancesPlansPage; },
  "default": function() { return /* binding */ plan_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/luxon/src/luxon.js + 23 modules
var luxon = __webpack_require__(30120);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/lib/format-date.ts
var format_date = __webpack_require__(68984);
// EXTERNAL MODULE: ./src/shared/ui/modal/modal.tsx + 7 modules
var modal = __webpack_require__(4629);
// EXTERNAL MODULE: ./src/shared/ui/entity/entity.tsx + 3 modules
var entity = __webpack_require__(51978);
// EXTERNAL MODULE: ./src/modules/finances/entities/month-plan/choose-fp-modal.module.scss
var choose_fp_modal_module = __webpack_require__(43690);
var choose_fp_modal_module_default = /*#__PURE__*/__webpack_require__.n(choose_fp_modal_module);
;// CONCATENATED MODULE: ./src/modules/finances/entities/month-plan/choose-fp-modal.tsx






const ChooseFpModal = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal */.u, {
        onClose: props.close,
        width: 450,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Header */.u.Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Title */.u.Title, {
                    children: [
                        "Финансовые планирования",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                "за\xa0",
                                (0,format_date/* formatDate */.p6)(props.data.from, {
                                    year: undefined,
                                    month: undefined
                                }),
                                "—",
                                (0,format_date/* formatDate */.p6)(props.data.to, {
                                    year: undefined
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Body */.u.Body, {
                children: props.data.financialPlans.map((it)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(entity/* Entity */.J, {
                        hover: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                    href: props.route.results.id(it.id).href,
                                    className: (choose_fp_modal_module_default()).link,
                                    children: [
                                        (0,format_date/* formatDate */.p6)(it.from),
                                        " — ",
                                        (0,format_date/* formatDate */.p6)(it.to),
                                        it.status === "DRAFT" && ", черновик",
                                        it.status === "ON_APPROVAL" && ", на утверждении"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        "Создано ",
                                        (0,format_date/* formatDate */.p6)(it.createdAt)
                                    ]
                                }),
                                right: true
                            })
                        ]
                    }, it.id))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Actions */.u.Actions, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                    onClick: props.close,
                    children: "Закрыть"
                })
            })
        ]
    });
};
ChooseFpModal.defaultProps = {};

// EXTERNAL MODULE: ./src/modules/finances/_shared/percent/percent.tsx
var percent = __webpack_require__(98424);
// EXTERNAL MODULE: ./src/pages/_router.tsx
var _router = __webpack_require__(8254);
// EXTERNAL MODULE: ./src/shared/lib/capitalize.ts
var capitalize = __webpack_require__(2629);
// EXTERNAL MODULE: ./src/shared/lib/format-number.ts
var format_number = __webpack_require__(9195);
// EXTERNAL MODULE: ./src/shared/lib/format-percent.ts
var format_percent = __webpack_require__(69385);
// EXTERNAL MODULE: ./src/shared/lib/use-modal.tsx
var use_modal = __webpack_require__(74363);
// EXTERNAL MODULE: ./src/shared/lib/pluralize.tsx
var pluralize = __webpack_require__(25819);
// EXTERNAL MODULE: ./src/shared/ui/icon/down.svg
var down = __webpack_require__(83083);
// EXTERNAL MODULE: ./src/shared/ui/status-dot/status-dot.tsx
var status_dot = __webpack_require__(65358);
// EXTERNAL MODULE: ./src/shared/ui/entity-form/entity-form.tsx
var entity_form = __webpack_require__(37641);
// EXTERNAL MODULE: ./src/shared/ui/tooltip/tooltip.tsx
var tooltip = __webpack_require__(72478);
// EXTERNAL MODULE: ./src/shared/ui/badge/badge.tsx
var badge = __webpack_require__(79859);
// EXTERNAL MODULE: ./src/modules/finances/entities/month-plan/month-plan-entity.module.scss
var month_plan_entity_module = __webpack_require__(12001);
var month_plan_entity_module_default = /*#__PURE__*/__webpack_require__.n(month_plan_entity_module);
;// CONCATENATED MODULE: ./src/modules/finances/entities/month-plan/month-plan-entity.tsx











const MonthPlanEntity = (props)=>{
    var _props_currentFP, _props_currentFP1;
    const data = props.data;
    const date = luxon/* DateTime.local */.ou.local(props.data.year, props.data.month);
    const hasExpiredWeeks = !!props.data.weeks.find((it)=>!it.closed && it.to < new Date());
    const route = _router/* default.company */.Z.company(props.companySlug).finances.yearMonth(props.data.year, props.data.month);
    const draft = ((_props_currentFP = props.currentFP) === null || _props_currentFP === void 0 ? void 0 : _props_currentFP.monthPlanId) === props.data.id && ((_props_currentFP1 = props.currentFP) === null || _props_currentFP1 === void 0 ? void 0 : _props_currentFP1.status) !== "APPROVED" ? props.currentFP : undefined;
    const weeks = (0,react.useMemo)(()=>{
        const now = new Date();
        return data.weeks.map((it, index)=>{
            if (data.status === "DRAFT" || data.status === "ON_APPROVAL") return {
                ...it,
                status: "none"
            };
            const planningNow = index === (draft === null || draft === void 0 ? void 0 : draft.monthWeekPosition);
            const expired = !it.closed && it.to < now;
            const currentWeek = it.from < now && now < it.to;
            let status = "none";
            if (currentWeek) {
                status = "current";
            }
            if (expired) {
                status = "expired";
            }
            if (planningNow) {
                status = "planning";
            }
            return {
                ...it,
                status
            };
        });
    }, [
        data,
        draft
    ]);
    const status = (0,react.useMemo)(()=>{
        if (data.status !== "APPROVED" && data.status !== "APPROVED_AND_HAS_FINANCIAL_PLAN") return "none";
        let hasExpired = false;
        let hasPlanning = false;
        let hasCurrent = false;
        weeks.forEach((it)=>{
            if (it.status === "expired") hasExpired = true;
            if (it.status === "planning") hasPlanning = true;
            if (it.status === "current") hasCurrent = true;
        });
        if (hasExpired) return "expired";
        if (hasPlanning) return "planning";
        if (hasCurrent) return "current";
        return "none";
    }, [
        weeks,
        data.status
    ]);
    const [open, setOpen] = (0,react.useState)(props.initialOpen);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(entity/* Entity */.J, {
                className: classnames_default()((month_plan_entity_module_default()).month_plan_entity, open && (month_plan_entity_module_default()).open, props.className),
                style: props.style,
                htmlId: props.htmlId,
                hover: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (month_plan_entity_module_default()).opener,
                        onClick: (e)=>{
                            e.stopPropagation();
                            setOpen((it)=>!it);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(down/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                            href: route.href,
                            className: (month_plan_entity_module_default()).link,
                            children: [
                                (0,capitalize/* capitalize */.k)(date.setLocale("ru").toLocaleString({
                                    month: "long"
                                })),
                                status === "planning" && /*#__PURE__*/ (0,jsx_runtime.jsx)(status_dot/* StatusDot */.z, {
                                    status: "blue",
                                    className: classnames_default()(open && (month_plan_entity_module_default()).transparent),
                                    style: {
                                        marginLeft: 8
                                    }
                                }),
                                status === "expired" && /*#__PURE__*/ (0,jsx_runtime.jsx)(status_dot/* StatusDot */.z, {
                                    status: "red",
                                    className: classnames_default()(open && (month_plan_entity_module_default()).transparent),
                                    style: {
                                        marginLeft: 8
                                    }
                                }),
                                status === "current" && /*#__PURE__*/ (0,jsx_runtime.jsx)(status_dot/* StatusDot */.z, {
                                    status: "white",
                                    className: classnames_default()(open && (month_plan_entity_module_default()).transparent),
                                    style: {
                                        marginLeft: 8
                                    }
                                })
                            ]
                        }),
                        description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (month_plan_entity_module_default()).primary,
                            children: [
                                (0,format_date/* formatDate */.p6)(data.from),
                                " — ",
                                (0,format_date/* formatDate */.p6)(data.to)
                            ]
                        }),
                        width: 130
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (month_plan_entity_module_default()).group,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                title: "План дохода",
                                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (month_plan_entity_module_default()).plan,
                                    children: (0,format_number/* formatNumber */.u)(data.planIncome || "—")
                                }),
                                width: 95,
                                label: true,
                                right: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                title: "Доход",
                                description: (0,format_number/* formatNumber */.u)(data.factIncome || "—"),
                                width: 85,
                                label: true,
                                right: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                title: "%",
                                description: data.factIncome ? (0,format_percent/* formatPercent */.T)(data.factIncome / data.planIncome) : "",
                                width: 45,
                                label: true,
                                right: true,
                                className: (month_plan_entity_module_default()).percent
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (month_plan_entity_module_default()).group,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                title: "План маржи",
                                description: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (month_plan_entity_module_default()).plan,
                                    children: (0,format_number/* formatNumber */.u)(data.planMarginProfit || "—")
                                }),
                                width: 95,
                                label: true,
                                right: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                title: "Маржа",
                                description: (0,format_number/* formatNumber */.u)(data.factMarginProfit || "—"),
                                width: 85,
                                label: true,
                                right: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                title: "%",
                                description: data.factMarginProfit ? (0,format_percent/* formatPercent */.T)(data.factMarginProfit / data.planMarginProfit) : "",
                                width: 45,
                                label: true,
                                right: true,
                                className: (month_plan_entity_module_default()).percent
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(entity/* Entity.Actions */.J.Actions, {
                        className: (month_plan_entity_module_default()).actions,
                        children: [
                            data.status === "DRAFT" && "черновик",
                            data.status === "ON_APPROVAL" && "на утверждении"
                        ]
                    })
                ]
            }),
            open && /*#__PURE__*/ (0,jsx_runtime.jsx)(entity_form/* EntityForm */.D, {
                className: (month_plan_entity_module_default()).footer,
                children: weeks.map((it, weekNumber)=>{
                    var _it_financialPlans_;
                    const showFact = it.financialPlans.length !== 0;
                    const noFPs = it.financialPlans.length === 0;
                    const oneFP = it.financialPlans.length === 1;
                    const fewFPs = it.financialPlans.length >= 2;
                    const Component = oneFP ? (link_default()) : "div";
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Component, {
                        href: route.results.id((_it_financialPlans_ = it.financialPlans[0]) === null || _it_financialPlans_ === void 0 ? void 0 : _it_financialPlans_.id).href,
                        className: classnames_default()((month_plan_entity_module_default()).week, !noFPs && (month_plan_entity_module_default()).hover, it.closed && (month_plan_entity_module_default()).closed),
                        onClick: ()=>{
                            if (!fewFPs) return;
                            use_modal/* Modals.open */.nK.open(ChooseFpModal, {
                                data: it,
                                route
                            });
                        },
                        children: [
                            it.status === "expired" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (month_plan_entity_module_default()).status,
                                title: "Пропущено финансовое планирование",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(status_dot/* StatusDot */.z, {
                                    status: "red"
                                })
                            }),
                            it.status === "current" && !hasExpiredWeeks && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (month_plan_entity_module_default()).status,
                                title: "Текущая неделя",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(status_dot/* StatusDot */.z, {
                                    status: "white"
                                })
                            }),
                            it.status === "planning" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (month_plan_entity_module_default()).status,
                                title: "Сейчас проводится планирование",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(status_dot/* StatusDot */.z, {
                                    status: "blue"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (month_plan_entity_module_default()).date,
                                children: [
                                    (0,format_date/* formatDate */.p6)(it.from, {
                                        year: undefined,
                                        month: undefined
                                    }),
                                    " —",
                                    " ",
                                    (0,format_date/* formatDate */.p6)(it.to, {
                                        year: undefined
                                    }),
                                    fewFPs && /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* Tooltip */.u, {
                                        label: "За неделю провели ".concat((0,pluralize/* pluralize */._)(it.financialPlans.length, {
                                            one: (it)=>"".concat(it, "\xa0финансовое планирование"),
                                            few: (it)=>"".concat(it, "\xa0финансовых планирования"),
                                            many: (it)=>"".concat(it, "\xa0финансовых планирований"),
                                            value2: (it)=>"два финансовых планирования",
                                            value3: (it)=>"три финансовых планирования",
                                            value4: (it)=>"четыре финансовых планирования",
                                            value5: (it)=>"пять финансовых планирования",
                                            value6: (it)=>"шесть финансовых планирования",
                                            value7: (it)=>"семь финансовых планирования"
                                        })),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                marginLeft: 8
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* Badge */.C, {
                                                variant: "gray-subtle",
                                                size: "sm",
                                                children: it.financialPlans.length
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (month_plan_entity_module_default()).group,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: classnames_default()((month_plan_entity_module_default()).income_plan, (month_plan_entity_module_default()).plan),
                                        children: (0,format_number/* formatNumber */.u)(it.plan.incomeTotal || undefined) || "—"
                                    }),
                                    showFact && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (month_plan_entity_module_default()).income_fact,
                                                children: (0,format_number/* formatNumber */.u)(it.fact.incomeTotal)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: classnames_default()((month_plan_entity_module_default()).income_percent),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(percent/* Percent */.g, {
                                                    colorized: it.closed,
                                                    children: it.fact.incomeTotal / it.plan.incomeTotal
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (month_plan_entity_module_default()).group,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: classnames_default()((month_plan_entity_module_default()).margin_plan, (month_plan_entity_module_default()).plan),
                                        children: (0,format_number/* formatNumber */.u)(it.plan.marginProfit || undefined) || "—"
                                    }),
                                    showFact && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (month_plan_entity_module_default()).margin_fact,
                                                children: (0,format_number/* formatNumber */.u)(it.fact.marginProfit)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (month_plan_entity_module_default()).margin_percent,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(percent/* Percent */.g, {
                                                    colorized: it.closed,
                                                    children: it.fact.marginProfit / it.plan.marginProfit
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, weekNumber);
                })
            })
        ]
    });
};
MonthPlanEntity.defaultProps = {
    initialOpen: false
};

// EXTERNAL MODULE: ./src/modules/finances/widgets/month-plan-list/ui/month-plan-next/month-plan-next-entity.module.scss
var month_plan_next_entity_module = __webpack_require__(47359);
var month_plan_next_entity_module_default = /*#__PURE__*/__webpack_require__.n(month_plan_next_entity_module);
// EXTERNAL MODULE: ./src/shared/ui/button/button.tsx
var button_button = __webpack_require__(76780);
;// CONCATENATED MODULE: ./src/modules/finances/widgets/month-plan-list/ui/month-plan-next/month-plan-next-entity.tsx






const MonthPlanNextEntity = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(entity/* Entity */.J, {
        className: classnames_default()((month_plan_next_entity_module_default()).month_plan_next_entity, props.className),
        style: props.style,
        htmlId: props.htmlId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    width: 20
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                title: (0,capitalize/* capitalize */.k)(new Date(props.data.year, props.data.month - 1).toLocaleString("ru-RU", {
                    month: "long"
                })),
                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (month_plan_next_entity_module_default()).primary,
                    children: [
                        (0,format_date/* formatDate */.p6)(props.data.from),
                        " — ",
                        (0,format_date/* formatDate */.p6)(props.data.to)
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Actions */.J.Actions, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                    type: "secondary",
                    size: "small",
                    onClick: ()=>props.onCreate(props.data),
                    style: {
                        marginLeft: "auto"
                    },
                    children: "Спланировать"
                })
            })
        ]
    });
MonthPlanNextEntity.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/api/init.tsx + 231 modules
var init = __webpack_require__(32636);
;// CONCATENATED MODULE: ./src/modules/finances/widgets/month-plan-list/ui/create-first/create-first.tsx





const CreateFirst = (props)=>{
    var _prevPlan_data;
    const current = luxon/* DateTime.now */.ou.now();
    const prev = current.minus({
        month: 1
    });
    const next = current.plus({
        month: 1
    });
    const currentPlan = init/* api.monthPlan.useMonthPlanCommonNextMonthPlan */.h.monthPlan.useMonthPlanCommonNextMonthPlan(props.companySlug, current.year, current.month);
    const prevPlan = init/* api.monthPlan.useMonthPlanCommonNextMonthPlan */.h.monthPlan.useMonthPlanCommonNextMonthPlan(props.companySlug, prev.year, prev.month);
    const nextPLan = init/* api.monthPlan.useMonthPlanCommonNextMonthPlan */.h.monthPlan.useMonthPlanCommonNextMonthPlan(props.companySlug, next.year, next.month);
    const showPrev = ((_prevPlan_data = prevPlan.data) === null || _prevPlan_data === void 0 ? void 0 : _prevPlan_data.to) > new Date();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            nextPLan.data && /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthPlanNextEntity, {
                data: nextPLan.data,
                onCreate: props.onCreate
            }),
            currentPlan.data && /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthPlanNextEntity, {
                data: currentPlan.data,
                onCreate: props.onCreate
            }),
            prevPlan.data && /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthPlanNextEntity, {
                data: prevPlan.data,
                onCreate: props.onCreate
            })
        ]
    });
};
CreateFirst.defaultProps = {};

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/shared/ui/list/list.tsx
var list = __webpack_require__(30954);
;// CONCATENATED MODULE: ./src/modules/finances/widgets/month-plan-list/lib/next-month-plan-date.ts

const nextMonthPlanDate = (monthPlans)=>{
    if (!monthPlans) return null;
    if (monthPlans.length === 0) return luxon/* DateTime.now */.ou.now();
    if (monthPlans.find((it)=>it.status !== "APPROVED_AND_HAS_FINANCIAL_PLAN")) return null;
    const lastPlan = monthPlans[0];
    return luxon/* DateTime.local */.ou.local(lastPlan.year, lastPlan.month + 1);
};

;// CONCATENATED MODULE: ./src/modules/finances/widgets/month-plan-list/lib/get-open-month.ts
const getOpenMonth = function() {
    let monthPlans = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    let open = undefined;
    for (const monthPlan of monthPlans){
        if (monthPlan.weeks.find((it)=>!it.closed)) {
            open = monthPlan;
        } else {
            break;
        }
    }
    return open;
};

// EXTERNAL MODULE: ./src/modules/finances/widgets/month-plan-list/month-plan-list.module.scss
var month_plan_list_module = __webpack_require__(47954);
var month_plan_list_module_default = /*#__PURE__*/__webpack_require__.n(month_plan_list_module);
// EXTERNAL MODULE: ./src/modules/finances/widgets/month-plan-list/ui/financial-planning-row/financial-planning-row.module.scss
var financial_planning_row_module = __webpack_require__(60140);
var financial_planning_row_module_default = /*#__PURE__*/__webpack_require__.n(financial_planning_row_module);
;// CONCATENATED MODULE: ./src/modules/finances/widgets/month-plan-list/ui/financial-planning-row/financial-planning-row.tsx










const FinancialPlanningRow = (props)=>{
    var _financialPlans_data;
    const { query  } = (0,router.useRouter)();
    const companySlug = query.company;
    const financialPlans = init/* api.financialPlan.useFinancialPlanList */.h.financialPlan.useFinancialPlanList(companySlug);
    const draftFinancialPlan = (_financialPlans_data = financialPlans.data) === null || _financialPlans_data === void 0 ? void 0 : _financialPlans_data.find((it)=>it.status === "DRAFT" || it.status === "ON_APPROVAL");
    const draftMonthPlan = init/* api.monthPlan.useMonthPlanGet */.h.monthPlan.useMonthPlanGet(companySlug, draftFinancialPlan === null || draftFinancialPlan === void 0 ? void 0 : draftFinancialPlan.monthPlanId);
    const monthPlanList = init/* api.monthPlan.useMonthPlanList */.h.monthPlan.useMonthPlanList(companySlug);
    const approvedPlans = (0,react.useMemo)(()=>{
        var _monthPlanList_data;
        return (_monthPlanList_data = monthPlanList.data) === null || _monthPlanList_data === void 0 ? void 0 : _monthPlanList_data.filter((it)=>it.status === "APPROVED" || it.status === "APPROVED_AND_HAS_FINANCIAL_PLAN");
    }, [
        monthPlanList.data
    ]);
    const now = (0,react.useMemo)(()=>new Date(), []);
    const expiredWeeks = (0,react.useMemo)(()=>{
        const weeks = approvedPlans === null || approvedPlans === void 0 ? void 0 : approvedPlans.map((it)=>it.weeks).flat();
        return weeks === null || weeks === void 0 ? void 0 : weeks.filter((it)=>it.to < now && !it.closed).sort((a, b)=>a.from.getTime() - b.from.getTime());
    }, [
        approvedPlans,
        now
    ]);
    const onCreate = async ()=>{
        const resp = await init/* api.financialPlan.financialPlanCreate */.h.financialPlan.financialPlanCreate(companySlug);
        await router_default().push(_router/* default.company */.Z.company(companySlug).finances.yearMonth(resp.year, resp.month).results.id(resp.id).href);
    };
    if (draftFinancialPlan && draftMonthPlan.data) {
        const { from , to  } = draftFinancialPlan;
        const { year , month  } = draftMonthPlan.data;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(entity/* Entity */.J, {
            className: classnames_default()((financial_planning_row_module_default()).financial_planning_row, props.className),
            style: props.style,
            htmlId: props.htmlId,
            children: [
                "Сейчас подводятся итоги ",
                (0,format_date/* formatDate */.p6)(from),
                " — ",
                (0,format_date/* formatDate */.p6)(to),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: _router/* default.company */.Z.company(companySlug).finances.yearMonth(year, month).results.id(draftFinancialPlan.id).href,
                    children: "Продолжить планирование"
                })
            ]
        });
    }
    if ((expiredWeeks === null || expiredWeeks === void 0 ? void 0 : expiredWeeks.length) === 1) {
        const { from: from1 , to: to1  } = expiredWeeks[0];
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(entity/* Entity */.J, {
            className: classnames_default()((financial_planning_row_module_default()).financial_planning_row, props.className),
            style: props.style,
            htmlId: props.htmlId,
            children: [
                "Пропущено планирование за ",
                (0,format_date/* formatDate */.p6)(from1),
                " — ",
                (0,format_date/* formatDate */.p6)(to1),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: onCreate,
                    children: "Провести планирование"
                })
            ]
        });
    }
    if (expiredWeeks && expiredWeeks.length > 1) {
        const { from: from2 , to: to2  } = expiredWeeks[0];
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(entity/* Entity */.J, {
            className: classnames_default()((financial_planning_row_module_default()).financial_planning_row, props.className),
            style: props.style,
            htmlId: props.htmlId,
            children: [
                "Пропущено",
                " ",
                (0,pluralize/* pluralize */._)(expiredWeeks.length, {
                    one: (it)=>"".concat(it, " финансовое планирование"),
                    few: (it)=>"".concat(it, " финансовых планирования"),
                    many: (it)=>"".concat(it, " финансовых планирований")
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    onClick: onCreate,
                    children: [
                        "Провести планирование за ",
                        (0,format_date/* formatDate */.p6)(from2),
                        " — ",
                        (0,format_date/* formatDate */.p6)(to2),
                        " "
                    ]
                })
            ]
        });
    }
    return null;
};
FinancialPlanningRow.defaultProps = {};

;// CONCATENATED MODULE: ./src/modules/finances/widgets/month-plan-list/month-plan-list.tsx












const MonthPlanList = (props)=>{
    var _currentFPResp_data, _props_data, _props_data1;
    const nextDate = (0,react.useMemo)(()=>nextMonthPlanDate(props.data), [
        props.data
    ]);
    const monthPlanNext = init/* api.monthPlan.useMonthPlanCommonNextMonthPlan */.h.monthPlan.useMonthPlanCommonNextMonthPlan(props.companySlug, nextDate === null || nextDate === void 0 ? void 0 : nextDate.year, nextDate === null || nextDate === void 0 ? void 0 : nextDate.month);
    const currentFPResp = init/* api.financialPlanCommon.useFinancialPlanCommonLastDraftOrOnApproval */.h.financialPlanCommon.useFinancialPlanCommonLastDraftOrOnApproval(props.companySlug);
    const currentFP = (_currentFPResp_data = currentFPResp.data) === null || _currentFPResp_data === void 0 ? void 0 : _currentFPResp_data.financialPlan;
    const openMonth = (0,react.useMemo)(()=>getOpenMonth(props.data), [
        props.data
    ]);
    const onCreate = async (data)=>{
        const draft = await init/* api.monthPlan.monthPlanCreate */.h.monthPlan.monthPlanCreate(props.companySlug, data);
        await router_default().push(_router/* default.company */.Z.company(props.companySlug).finances.yearMonth(draft.year, draft.month).href);
    };
    if (((_props_data = props.data) === null || _props_data === void 0 ? void 0 : _props_data.length) === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((month_plan_list_module_default()).month_plan_list, props.className),
            style: props.style,
            id: props.htmlId,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateFirst, {
                onCreate: onCreate,
                companySlug: props.companySlug
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* List */.a, {
        ...props,
        className: classnames_default()((month_plan_list_module_default()).month_plan_list, props.className),
        header: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                monthPlanNext.data && /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthPlanNextEntity, {
                    data: monthPlanNext.data,
                    onCreate: onCreate
                }),
                !openMonth && !!((_props_data1 = props.data) === null || _props_data1 === void 0 ? void 0 : _props_data1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FinancialPlanningRow, {
                    companySlug: props.companySlug,
                    monthPlanList: props.data
                })
            ]
        }),
        renderItem: (it)=>{
            const open = (openMonth === null || openMonth === void 0 ? void 0 : openMonth.id) === it.id;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthPlanEntity, {
                        data: it,
                        companySlug: props.companySlug,
                        currentFP: currentFP,
                        initialOpen: open
                    }),
                    open && /*#__PURE__*/ (0,jsx_runtime.jsx)(FinancialPlanningRow, {
                        companySlug: props.companySlug,
                        monthPlanList: props.data
                    })
                ]
            });
        }
    });
};
MonthPlanList.defaultProps = {};

// EXTERNAL MODULE: ./src/modules/layout/ui/title/title.tsx
var title = __webpack_require__(98730);
// EXTERNAL MODULE: ./src/modules/my-permissions/use-my-permissions.ts
var use_my_permissions = __webpack_require__(80665);
// EXTERNAL MODULE: ./src/pages/[company]/finances/education/index.page.tsx + 5 modules
var index_page = __webpack_require__(27334);
// EXTERNAL MODULE: ./src/pages/[company]/finances/education/table-of-content.page.tsx
var table_of_content_page = __webpack_require__(77414);
// EXTERNAL MODULE: ./src/pages/[company]/finances/funding-requests/index.page.tsx
var funding_requests_index_page = __webpack_require__(39772);
// EXTERNAL MODULE: ./src/pages/[company]/finances/_layout.tsx + 1 modules
var _layout = __webpack_require__(89220);
;// CONCATENATED MODULE: ./src/pages/[company]/finances/plan.page.tsx














const FinancesPlansPage = ()=>{
    var _financialPlans_data, _monthPlanList_data, _settings_data;
    const companySlug = (0,router.useRouter)().query.company;
    const monthPlanList = init/* api.monthPlan.useMonthPlanList */.h.monthPlan.useMonthPlanList(companySlug);
    const settings = init/* api.financeSettings.useFinanceSettingsGet */.h.financeSettings.useFinanceSettingsGet(companySlug);
    const financialPlans = init/* api.financialPlan.useFinancialPlanList */.h.financialPlan.useFinancialPlanList(companySlug);
    const draftFinancialPlan = (_financialPlans_data = financialPlans.data) === null || _financialPlans_data === void 0 ? void 0 : _financialPlans_data.find((it)=>it.status === "DRAFT" || it.status === "ON_APPROVAL");
    const draftMonthPlan = init/* api.monthPlan.useMonthPlanGet */.h.monthPlan.useMonthPlanGet(companySlug, draftFinancialPlan === null || draftFinancialPlan === void 0 ? void 0 : draftFinancialPlan.monthPlanId);
    const approvedPlans = (0,react.useMemo)(()=>{
        var _monthPlanList_data;
        return (_monthPlanList_data = monthPlanList.data) === null || _monthPlanList_data === void 0 ? void 0 : _monthPlanList_data.filter((it)=>it.status === "APPROVED" || it.status === "APPROVED_AND_HAS_FINANCIAL_PLAN");
    }, [
        monthPlanList.data
    ]);
    const nextFPResp = init/* api.financialPlanCommon.useFinancialPlanCommonNextFinancialPlan */.h.financialPlanCommon.useFinancialPlanCommonNextFinancialPlan(companySlug);
    const onCreate = async ()=>{
        const resp = await init/* api.financialPlan.financialPlanCreate */.h.financialPlan.financialPlanCreate(companySlug);
        await router_default().push(_router/* default.company */.Z.company(companySlug).finances.yearMonth(resp.year, resp.month).results.id(resp.id).href);
    };
    const hasExpired = !!((_monthPlanList_data = monthPlanList.data) === null || _monthPlanList_data === void 0 ? void 0 : _monthPlanList_data.find((it)=>it.weeks.find((it)=>!it.closed && it.to < new Date())));
    const permissions = (0,use_my_permissions/* useMyPermissions */.J)(companySlug);
    if ((_settings_data = settings.data) === null || _settings_data === void 0 ? void 0 : _settings_data.education) {
        if (settings.data.educationStep !== 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_of_content_page["default"], {});
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_page["default"], {});
    }
    if (!permissions) return /*#__PURE__*/ (0,jsx_runtime.jsx)(_layout/* CompanyFinancesLayout */.G, {});
    if (!permissions.finances.budgets.read) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(funding_requests_index_page["default"], {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(_layout/* CompanyFinancesLayout */.G, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* Title */.D, {
                actions: (permissions === null || permissions === void 0 ? void 0 : permissions.finances.plannings.write) && (approvedPlans === null || approvedPlans === void 0 ? void 0 : approvedPlans.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !draftFinancialPlan && nextFPResp.data && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                            type: "secondary",
                            onClick: onCreate,
                            children: "Провести планирование"
                        }),
                        draftFinancialPlan && draftMonthPlan.data && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: _router/* default.company */.Z.company(companySlug).finances.yearMonth(draftMonthPlan.data.year, draftMonthPlan.data.month).results.id(draftFinancialPlan.id).href,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                children: "Продолжить планирование"
                            })
                        })
                    ]
                }),
                children: "Месячные бюджеты"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthPlanList, {
                companySlug: companySlug,
                ...monthPlanList
            })
        ]
    });
};
/* harmony default export */ var plan_page = (FinancesPlansPage);


/***/ }),

/***/ 69385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ formatPercent; }
/* harmony export */ });
/* harmony import */ var _format_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9195);

const formatPercent = (value)=>{
    const num = Number(value);
    if (!Number.isFinite(num)) return undefined;
    return (0,_format_number__WEBPACK_IMPORTED_MODULE_0__/* .formatNumber */ .u)(Math.floor(num * 100)) + "%";
};


/***/ }),

/***/ 79859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ Badge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _badge_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28613);
/* harmony import */ var _badge_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_badge_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Badge = (param)=>{
    let { variant , size ="md" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_badge_module_scss__WEBPACK_IMPORTED_MODULE_3___default().badge), (_badge_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[variant], (_badge_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[size], props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
Badge.defaultProps = {};


/***/ }),

/***/ 65358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ StatusDot; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _status_dot_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1492);
/* harmony import */ var _status_dot_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_status_dot_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const StatusDot = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        title: props.description,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_status_dot_module_scss__WEBPACK_IMPORTED_MODULE_3___default().status_dot), props.status === "red" && (_status_dot_module_scss__WEBPACK_IMPORTED_MODULE_3___default().red), props.status === "yellow" && (_status_dot_module_scss__WEBPACK_IMPORTED_MODULE_3___default().yellow), props.status === "green" && (_status_dot_module_scss__WEBPACK_IMPORTED_MODULE_3___default().green), props.status === "blue" && (_status_dot_module_scss__WEBPACK_IMPORTED_MODULE_3___default().blue), props.status === "white" && (_status_dot_module_scss__WEBPACK_IMPORTED_MODULE_3___default().white), props.className),
        style: props.style,
        id: props.htmlId
    });
};
StatusDot.defaultProps = {};


/***/ }),

/***/ 80213:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"red":"percent_red__LAb0Z","green":"percent_green__d15hc"};

/***/ }),

/***/ 43690:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"choose-fp-modal_link__mwRht","group":"choose-fp-modal_group__vEjAy","percent":"choose-fp-modal_percent__8E3zD"};

/***/ }),

/***/ 12001:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"month_plan_entity":"month-plan-entity_month_plan_entity__pWtSA","opener":"month-plan-entity_opener__tJImR","link":"month-plan-entity_link__BQ7bG","income":"month-plan-entity_income__U_BcF","margin":"month-plan-entity_margin__1Ig8R","percent":"month-plan-entity_percent__868Vj","transparent":"month-plan-entity_transparent__Vs5Qw","group":"month-plan-entity_group__z_CkO","footer":"month-plan-entity_footer__DrMMj","week":"month-plan-entity_week__LjyA2","hover":"month-plan-entity_hover__u0_vS","closed":"month-plan-entity_closed__XRpzR","status":"month-plan-entity_status__SFFop","date":"month-plan-entity_date__CdVhZ","income_plan":"month-plan-entity_income_plan__0Qpj0","income_fact":"month-plan-entity_income_fact__6q1tg","income_percent":"month-plan-entity_income_percent__tBHh_","margin_plan":"month-plan-entity_margin_plan__1X_dz","margin_fact":"month-plan-entity_margin_fact__wEHlw","margin_percent":"month-plan-entity_margin_percent__xWhmG","actions":"month-plan-entity_actions__iT_mO","primary":"month-plan-entity_primary__Z0q7d","plan":"month-plan-entity_plan__LZekN"};

/***/ }),

/***/ 47954:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 60140:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"financial_planning_row":"financial-planning-row_financial_planning_row__elmde"};

/***/ }),

/***/ 47359:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"month-plan-next-entity_primary__pmIrc"};

/***/ }),

/***/ 16269:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"table_of_content":"table-of-content_table_of_content__PNxhc","inner":"table-of-content_inner__6tuj1","list":"table-of-content_list__rEO_r","item":"table-of-content_item__2LUDY","active":"table-of-content_active__SfPcB","number":"table-of-content_number___Y8_w"};

/***/ }),

/***/ 28613:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge__odM0f","blue":"badge_blue__8xSSM","blue-subtle":"badge_blue-subtle__bcorV","gray":"badge_gray__WEMcC","gray-subtle":"badge_gray-subtle__Gag_W","sm":"badge_sm__TWv5x","md":"badge_md__20pXH","lg":"badge_lg__phonX"};

/***/ }),

/***/ 1492:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"status_dot":"status-dot_status_dot__5TvFX","white":"status-dot_white__Z0EIU","red":"status-dot_red__VKAPi","yellow":"status-dot_yellow__Zlyg_","green":"status-dot_green__KU2dK","blue":"status-dot_blue__aIbAy"};

/***/ })

}]);